import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-97a0d7ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "camera-content",
  ref: "cameraPop"
}
const _hoisted_2 = {
  key: 0,
  class: "select-btn"
}
const _hoisted_3 = { class: "btn-list" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "pagination-list" }
const _hoisted_6 = { class: "channel-list" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("全部通道")
const _hoisted_8 = { class: "video-items video-items-option" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "players-box",
  class: "players-box"
}, null, -1))
const _hoisted_10 = {
  key: 0,
  class: "video-items-btn"
}
const _hoisted_11 = { class: "video-items-control" }
const _hoisted_12 = { class: "items-contro-btn" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-xiangshang" }, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "center" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "pause-btn" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-24gf-pause2" })
  ])
], -1))
const _hoisted_17 = { class: "video-items-advance" }
const _hoisted_18 = { class: "contro-btn-span" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-quanping-fangda-07" }, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "advance-btn-txt" }, "焦点前移", -1))
const _hoisted_21 = [
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-quanping-fangda-071" }, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "advance-btn-txt" }, "焦点后移", -1))
const _hoisted_24 = [
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = { class: "contro-btn-span" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-fangda1" }, null, -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "advance-btn-txt" }, "焦距变大", -1))
const _hoisted_28 = [
  _hoisted_26,
  _hoisted_27
]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-fangda2" }, null, -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "advance-btn-txt" }, "焦距变小", -1))
const _hoisted_31 = [
  _hoisted_29,
  _hoisted_30
]
const _hoisted_32 = { class: "channel-list" }
const _hoisted_33 = /*#__PURE__*/_createTextVNode("全部通道")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_Option = _resolveComponent("Option")!
  const _component_Select = _resolveComponent("Select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isSelected)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.btnInfo, (item, index) => {
              return (_openBlock(), _createElementBlock("button", {
                class: _normalizeClass(["btn-item", _ctx.pageSize === item.value ? 'active' : '']),
                onClick: ($event: any) => (_ctx.changeNum(item.value)),
                key: index
              }, _toDisplayString(item.label), 11, _hoisted_4))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Pagination, {
              simple: "",
              current: _ctx.currentPage,
              "onUpdate:current": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentPage) = $event)),
              "page-size": _ctx.pageSize,
              total: _ctx.videos.length,
              onChange: _ctx.onChange
            }, null, 8, ["current", "page-size", "total", "onChange"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_Select, {
              value: _ctx.curChannel,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.curChannel) = $event)),
              style: {"width":"120px","height":"34px"},
              onChange: _ctx.selectChange
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Option, { value: "all" }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                }),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.videos, (item, key) => {
                  return (_openBlock(), _createBlock(_component_Option, {
                    key: key,
                    value: item.url
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.channelName), 1)
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["value", "onChange"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      (_ctx.isSelected)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.decBtns, (val, key) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: key,
                    class: _normalizeClass(`slice control-${key} ${_ctx.clickedNum === val ? 'active' : ''}`),
                    onClick: ($event: any) => (_ctx.videoControl(val))
                  }, _hoisted_15, 10, _hoisted_13))
                }), 128)),
                _hoisted_16
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("span", _hoisted_18, [
                _createElementVNode("div", {
                  class: _normalizeClass(["items-advance-btn", _ctx.clickedNum === 10 ? 'active' : '']),
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.videoControl(10)))
                }, _hoisted_21, 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["items-advance-btn", _ctx.clickedNum === 11 ? 'active' : '']),
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.videoControl(11)))
                }, _hoisted_24, 2)
              ]),
              _createElementVNode("span", _hoisted_25, [
                _createElementVNode("div", {
                  class: _normalizeClass(["items-advance-btn", _ctx.clickedNum === 8 ? 'active' : '']),
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.videoControl(8)))
                }, _hoisted_28, 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["items-advance-btn", _ctx.clickedNum === 9 ? 'active' : '']),
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.videoControl(9)))
                }, _hoisted_31, 2)
              ])
            ]),
            _createElementVNode("div", _hoisted_32, [
              _createVNode(_component_Select, {
                value: _ctx.curChannel,
                "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.curChannel) = $event)),
                style: {"width":"120px","height":"34px"},
                onChange: _ctx.selectChange
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Option, { value: "all" }, {
                    default: _withCtx(() => [
                      _hoisted_33
                    ]),
                    _: 1
                  }),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.videos, (item, key) => {
                    return (_openBlock(), _createBlock(_component_Option, {
                      key: key,
                      value: item.url
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.channelName), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value", "onChange"])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 512))
}